import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { getApiBaseUrl } from './productpercabang/apiProductPercabang';
import { aktifkanWebPush, matikanWebPush, statusWebPush } from '../../utils/webPush';

/**
 * Saklar "Notifikasi pesanan (walau browser ditutup)": berlangganan Web Push untuk cabang akun ini. Pesanan baru dari menu QR
 * muncul sebagai notifikasi sistem (dengan suara/getar) walau tab atau browser ditutup. Butuh HTTPS atau localhost.
 */
const NotifikasiPush = ({ sx }) => {
  const [st, setSt] = useState({ didukung: true, izin: 'default', aktif: false });
  const [sibuk, setSibuk] = useState(false);
  const [galat, setGalat] = useState('');

  const muat = useCallback(() => statusWebPush().then(setSt), []);
  useEffect(() => { muat(); }, [muat]);

  const ubah = async (e) => {
    setGalat('');
    setSibuk(true);
    try {
      if (e.target.checked) await aktifkanWebPush({ apiBase: getApiBaseUrl(), jenis: 'staf' });
      else await matikanWebPush({ apiBase: getApiBaseUrl() });
    } catch (err) {
      setGalat(err?.response?.data?.message || err?.message || 'Gagal mengubah notifikasi');
    }
    await muat();
    setSibuk(false);
  };

  return (
    <Box sx={sx}>
      <FormControlLabel
        control={<Switch checked={st.aktif} onChange={ubah} disabled={sibuk || !st.didukung || st.izin === 'denied'} />}
        label={<Typography variant="body2">Notifikasi pesanan (walau browser ditutup)</Typography>}
      />
      {!st.didukung && (
        <Alert severity="info" sx={{ mt: 0.5, py: 0 }}>
          Browser ini belum bisa menerima notifikasi: butuh HTTPS (atau localhost) dan browser yang mendukung Web Push.
        </Alert>
      )}
      {st.didukung && st.izin === 'denied' && (
        <Alert severity="warning" sx={{ mt: 0.5, py: 0 }}>
          Izin notifikasi diblokir. Ubah di pengaturan situs browser (ikon gembok di alamat), lalu muat ulang halaman.
        </Alert>
      )}
      {galat && <Alert severity="error" sx={{ mt: 0.5, py: 0 }}>{galat}</Alert>}
    </Box>
  );
};

export default NotifikasiPush;
